// Юридические ссылки инстанса (оферта, политика ПДн).
// Источник — админ-настройки (GET /api/settings → oferta_url / privacy_policy_url),
// меняются без пересборки. До ответа API и при ошибке — дефолты бренд-пака.
import { useEffect, useState } from 'react';
import { fetchAppSettings, FOREVER } from './settings';
import BRAND from './brand';

const fallback = {
  ofertaUrl: BRAND.ofertaUrl,
  policyUrl: BRAND.policyUrl,
};

let cache = null;   // производное значение; ставится только при успехе, неудача не кэшируется

function fetchLegalLinks() {
  if (cache) return Promise.resolve(cache);
  return fetchAppSettings({ maxAgeMs: FOREVER })
    .then((s) => {
      cache = {
        ofertaUrl: s.oferta_url || fallback.ofertaUrl,
        policyUrl: s.privacy_policy_url || fallback.policyUrl,
      };
      return cache;
    })
    .catch(() => fallback);
}

export function useLegalLinks() {
  const [links, setLinks] = useState(cache || fallback);
  useEffect(() => {
    let alive = true;
    fetchLegalLinks().then((l) => { if (alive) setLinks(l); });
    return () => { alive = false; };
  }, []);
  return links;
}
